
const headers = [
  {
    label: 'เลขร้องทุกข์',
    field: 'complaintCode',
  },
  {
    label: 'วันที่ยื่นเรื่อง / ช่องทาง',
    field: 'complaintDate'
  },
  {
    label: 'ผู้ประกอบการ / ชื่อผู้ร้องทุกข์ หรือ ผู้มอบอำนาจ',
    field: 'companyName',
  },
  {
    label: 'วันที่ดำเนินการล่าสุด / สถานะล่าสุด',
    field: 'status',
  },
  {
    label: 'หน่วยงานรับผิดชอบ / ผู้รับผิดชอบ',
    field: 'operatorName',
  },
  {
    label: 'แบบฟอร์มรอดำเนินการ / แบบฟอร์มอนุมัติ',
    field: 'complaintForm',
  },
]

export default headers